module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-13.5f51f8bd.png";